import React from 'react';

/* 
  used in
  #1 /paybill ==> Pay page from menu ==> ==> pay services menu items section
  #2 /moremenu ==> More page from menu ==> ==> more options section
*/
function MenuCardList({ containerClass, count = 5, hideLabelIcon = false }) {
  return (
    <div class={`sec_top ${containerClass}`}>
      <ul class="link_style_menu p-0">
        {
          [...new Array(count)]?.map(
            (el, index) => {
              return (
                <li key={index}>
                  <div
                    class="link_style_item link_style_item_com1 flex_grp_align_center pointer"
                    style={{ padding: !hideLabelIcon ? '15px 10px' : '20px 10px' }}
                  >
                    <div class="flex_grp_align_center flex1">
                      {
                        !hideLabelIcon && (
                          <div class="left_icon shimmerBG shimmer-img-xs border-radious10" />
                        )
                      }
                      
                      <span className='shimmerBG shimmer-text-sm w-50'></span>
                    </div>
                    <div
                      class="shimmerBG shimmer-icon-xs"
                    />
                  </div>
                </li>
              );
            }
          )
        }
      </ul>
    </div>
  );
}

export default MenuCardList;
